import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLoaderComponent } from './global-loader.component';

@NgModule({
  declarations: [GlobalLoaderComponent],
  imports: [CommonModule],
  providers: [],
  exports: [GlobalLoaderComponent],
})
export class GlobalLoaderModule {}
